import script from "./CommunityDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityDialog.vue?vue&type=script&setup=true&lang=js"

import "./CommunityDialog.vue?vue&type=style&index=0&id=308310f5&lang=css"
import "./CommunityDialog.vue?vue&type=style&index=1&id=308310f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308310f5"]])

export default __exports__